import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Button, Callout, Container, Heading, Spinner } from "@radix-ui/themes";
import useFetch from "../../core/hooks/useFetch";
import AdminService from "../../core/services/AdminService";
import { useEffect, useRef, useState } from "react";
import { ISettings } from "../../core/types/services-types/admin-types";
import {renderAsync} from 'docx-preview'
import BillService from '../../core/services/BillService'
import {toast, ToastContainer} from 'react-toastify'
import { useNavigate } from "react-router";
import { AUTHED_ROUTES } from "../../routes/constants";
export default function BillFill() {
    const [settingsSite, setSettingsSite] = useState<ISettings>()
    const [template, setTemplate] = useState<Blob>()
    const templateRef = useRef<HTMLElement>(null)
    const navigation = useNavigate()
    const [fetchSettingsSite, isLoadingFetchSettingsSite, errorFetchSettingsSite, errorsFetchSettingsSite] = useFetch(async () => {
        const data = await AdminService.GethtmlTemplateBillDocument()
        setTemplate(data)
        if(templateRef.current) {
        await renderAsync(data, templateRef.current);
        }
    })

    const [fetchBillUser, isLoadingFetchBillUser, errorFetchBillUser, errorsFetchBillUser] = useFetch(async () => {
        if(templateRef.current?.innerHTML) {
        const data = await BillService.BillUserHTML(templateRef.current.innerHTML)
        toast.success("Счет успешно отправлен! Можете скачать его на странице аккаунта")
        navigation(AUTHED_ROUTES.ACCOUNT_ROUTE)
        }
    })

    useEffect(() => {
        fetchSettingsSite()
    }, [])

    useEffect(() => {
        if(errorFetchBillUser) toast.error(errorFetchBillUser)
    }, [errorFetchBillUser])

    useEffect(() => {
        if(errorFetchSettingsSite) toast.error(errorFetchSettingsSite)
    }, [errorFetchSettingsSite])

    return (
        <Container className="bill-fill bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto mt-10">
            <ToastContainer /> 
            <Container>
                <Heading>
                    Заполнить заявление требование
                </Heading>
            </Container>
            <Container className="mb-5">
                <Callout.Root className="mb-5">
	<Callout.Icon>
		<InfoCircledIcon />
	</Callout.Icon>
	<Callout.Text>
        <Container>Желтым - заполняете Вы</Container>
	</Callout.Text>
</Callout.Root>
            <Button onClick={async () => fetchBillUser()} loading={isLoadingFetchBillUser}>
                Отправить
            </Button>
            </Container>
          
            {isLoadingFetchSettingsSite && <Spinner />}
            <div 
            ref={templateRef}
            contentEditable 
            className="template" 
            />
               
        </Container>
    )
}